import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { THE_FAMILY_ID } from '@azure/msal-common';
import { APIResponseInterface } from '@core/interfaces/api-response.interface';
import { NotificationInterface } from '@core/interfaces/notification.interface';
import { NotificationModel } from '@core/models/notification.model';
import { BehaviorSubject, map, Observable, of, switchMap } from 'rxjs';
import { DateTimeService } from './date-time.service';

@Injectable({ providedIn: 'root' })
export class NotificationsService {
    private notifications: BehaviorSubject<NotificationModel[]> =
        new BehaviorSubject<NotificationModel[]>([]);

    constructor(
        private http: HttpClient,
        private dateTimeService: DateTimeService
    ) {}

    getUserNotifications() {
        this.http
            .get<APIResponseInterface<NotificationInterface[]>>(
                'users/notifications'
            )
            .pipe(
                map((response) => {
                    let result: NotificationModel[] = [];

                    if (response.data && response.data.length) {
                        result = response.data.map((x) => {
                            return new NotificationModel(
                                x,
                                this.dateTimeService
                            );
                        });
                    }
                    return result;
                })
            )
            .subscribe((data: NotificationModel[]) => {
                this.notifications.next(data);
            });
    }

    setNotificationsRead(ids: string[]): Observable<boolean> {
        return this.http
            .post(`users/notifications/read`, ids, { observe: 'response' })
            .pipe(
                switchMap((result: HttpResponse<any>) => {
                    if (result.ok) {
                        this.notifications.next(
                            this.notifications.getValue().filter(x => {
                                return !!!ids.find(y => y === x.id);
                            })
                        );
                        return of(true);
                    } else {
                        return of(false);
                    }
                })
            );
    }

    notificationChanges(): Observable<NotificationModel[]> {
        return this.notifications.asObservable();
    }

    addNotification(notification: NotificationInterface) {
        this.notifications.next([new NotificationModel(notification, this.dateTimeService),...this.notifications.getValue()]);
    }
}
